import { CellStyleRequestedEventArgs as CellStyleRequestedEventArgs_internal } from "./CellStyleRequestedEventArgs";
/**
 * Information about the style request for a cell.
*/
var IgrCellStyleRequestedEventArgs = /** @class */ /*@__PURE__*/ (function () {
    function IgrCellStyleRequestedEventArgs() {
        this._implementation = this.createImplementation();
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    }
    IgrCellStyleRequestedEventArgs.prototype.createImplementation = function () {
        return new CellStyleRequestedEventArgs_internal();
    };
    Object.defineProperty(IgrCellStyleRequestedEventArgs.prototype, "i", {
        /**
         * @hidden
         */
        get: function () {
            return this._implementation;
        },
        enumerable: false,
        configurable: true
    });
    IgrCellStyleRequestedEventArgs.prototype.onImplementationCreated = function () {
    };
    IgrCellStyleRequestedEventArgs.prototype._provideImplementation = function (i) {
        this._implementation = i;
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    };
    Object.defineProperty(IgrCellStyleRequestedEventArgs.prototype, "styleKey", {
        /**
         * The proposed style key for the cell. Used for recycling the cell.
        */
        get: function () {
            return this.i.styleKey;
        },
        set: function (v) {
            this.i.styleKey = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrCellStyleRequestedEventArgs.prototype, "resolvedValue", {
        /**
         * The resolved value for the cell.
        */
        get: function () {
            return this.i.resolvedValue;
        },
        set: function (v) {
            this.i.resolvedValue = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IgrCellStyleRequestedEventArgs.prototype, "rowNumber", {
        /**
         * The row number for the cell.
        */
        get: function () {
            return this.i.rowNumber;
        },
        set: function (v) {
            this.i.rowNumber = +v;
        },
        enumerable: false,
        configurable: true
    });
    return IgrCellStyleRequestedEventArgs;
}());
export { IgrCellStyleRequestedEventArgs };
//# sourceMappingURL=igr-cell-style-requested-event-args.js.map
